<template>
  <el-config-provider :locale="locale">
    <router-view />
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/lib/locale/lang/zh-cn';
import { defineComponent } from 'vue';

/**
 * element-plus.beta59后需要设置i18n，否则el-table等会出现英文
 * 详看：https://element-plus.org/#/zh-CN/component/i18n
 */
export default defineComponent({
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    return {
      locale: zhCn,
    };
  },
});
</script>
